module.exports = __webpack_public_path__ + "images/products/all-flavors-a1c833e4.png";